var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 110,
    viewBox: "0 0 107 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0743 79.8836L39.2575 109.909H75.2577L57.0745 79.8836H21.0743Z",
    fill: "#003563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0667 30.6244L67.8835 0.598511H31.8833L50.0665 30.6244H86.0667Z",
    fill: "#003563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0665 30.6244L21.0743 79.8836C4.92592 79.8836 -5.04475 62.2782 3.24921 48.4251L31.8833 0.598511L50.0665 30.6244Z",
    fill: "url(#paint0_linear_610_627)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0745 79.8836L86.0667 30.6244C102.215 30.6244 112.186 48.2298 103.892 62.0829L75.2577 109.909L57.0745 79.8836Z",
    fill: "url(#paint1_linear_610_627)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0667 30.6244L57.0745 79.8836H21.0743L50.0665 30.6244H86.0667Z",
    fill: "url(#paint2_linear_610_627)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_610_627",
    x1: 89.3135,
    y1: 22.2228,
    x2: 56.4024,
    y2: 101.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_610_627",
    x1: 17.7927,
    y1: 88.274,
    x2: 50.7038,
    y2: 8.74598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_610_627",
    x1: 53.5664,
    y1: 79.8836,
    x2: 53.5664,
    y2: 30.6244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E74340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F45655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FC6261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FA6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EE5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#D94040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC3333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetLogo);
export default __webpack_public_path__ + "static/media/fleetLogo.ce3cae3192f1c3b25dce0a5107cb5c84.svg";
export { ForwardRef as ReactComponent };